import {
  StoryblokServerComponent,
  storyblokEditable,
} from "@storyblok/react/rsc";

import type { PageContext } from "~lib/storyblok";

import { ampli } from "~lib/ampli/node";
import type { DynamicPageBlok } from "./types";

type DynamicPageProps = {
  blok: DynamicPageBlok;
} & PageContext;

/**
 * The main dynamic page when building out landing pages with sections etc.
 */
export function DynamicPage({
  blok,
  deviceId,
  featureFlags,
  ...rest
}: DynamicPageProps) {
  const featureFlag = blok.experimentKey
    ? featureFlags?.[blok.experimentKey]
    : null;

  const variantMatch = blok.variants?.find(
    variant => variant.name === featureFlag?.value,
  );
  const body = variantMatch ? variantMatch.body : blok.body;

  // Track the exposure, both if there is a match or it uses the "control" -> blok.body
  // TODO: use server side tracking here when new rsc PR is merged
  if (featureFlag?.value) {
    ampli.track(
      undefined,
      {
        event_type: "$exposure",
        event_properties: {
          flag_key: blok.experimentKey,
          variant: featureFlag.value,
        },
      },
      { device_id: deviceId },
    );
  }

  return (
    <main {...storyblokEditable(blok)} data-page-type="dynamic">
      {body?.map(nestedBlok => (
        <StoryblokServerComponent
          blok={nestedBlok}
          key={nestedBlok._uid}
          {...rest}
        />
      ))}
    </main>
  );
}
